import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || "";

export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "UTC";
  }
};

export const verifyTicketStatusApi = async (data: {
  ticketId: string;
  userTimezone?: string;
}) => {
  return axios.get(`${baseUrl}/user/payment/scan-ticket`, {
    params: {
      ...data,
      userTimezone: data.userTimezone ?? getUserTimezone(),
    },
  });
};
